import { elementType, func, node, object } from "prop-types";
import { forwardRef, useRef, useState } from "react";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import { FnrPopover } from "UI/FnrPopover2";

const FnrButtonPopper = forwardRef(
  /**
   * @param {object} param0
   * @param {import("react").ElementType} param0.Button - a component that accepts and click event
   * @param {object} param0.buttonProps - props passed to Button. onClick will be overwritten, so don't bother.
   * @param {import("react").ReactNode} param0.content - content to appear inside the popover.
   * @param {import("react").ReactNode} param0.children - content to appear inside the button.
   * @param {function} param0.onOpen - passed down to FnrPopover as such.
   * @param {function} param0.onClose - appended to end of onShouldClose function in FnrPopover
   * @param {any} param0.closeTrigger - anytime this changes, the popover will close
   * @returns
   */
  (
    {
      Button = FnrButtonWrapper,
      buttonProps = {},
      content,
      children,
      onOpen,
      onClose,
      ...rest
    },
    passedInRef
  ) => {
    const [showPopover, setShowPopover] = useState();
    const localRef = useRef();
    const ref = passedInRef || localRef;

    return (
      <>
        <Button
          {...buttonProps}
          showPopover={showPopover}
          ref={ref}
          onClick={() => setShowPopover(!showPopover)}
        >
          {children}
        </Button>
        <FnrPopover
          buttonRef={ref}
          show={showPopover}
          onShouldClose={() => {
            setShowPopover(false);
            if (typeof onClose === "function") onClose();
          }}
          onOpen={onOpen}
          {...rest}
        >
          {content}
        </FnrPopover>
      </>
    );
  }
);

export default FnrButtonPopper;

FnrButtonPopper.propTypes = {
  Button: elementType,
  buttonProps: object,
  content: node,
  children: node,
  onOpen: func,
  onClose: func,
};
